/* tslint:disable */
/* eslint-disable */
/**
 * TOM STORAGE SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateYardBlockBayDto } from '../model';
// @ts-ignore
import type { SlotDto } from '../model';
// @ts-ignore
import type { UpdateYardBlockBayDto } from '../model';
// @ts-ignore
import type { YardBlockBayDto } from '../model';
/**
 * YardBlockBaysApi - axios parameter creator
 */
export const YardBlockBaysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateYardBlockBayDto} [createYardBlockBayDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockBaysCreate: async (createYardBlockBayDto?: CreateYardBlockBayDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlockBays/Create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createYardBlockBayDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [yardBlockBayId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockBaysDelete: async (yardBlockBayId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlockBays/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (yardBlockBayId !== undefined) {
                localVarQueryParameter['yardBlockBayId'] = yardBlockBayId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [yardBlockId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockBaysGet: async (yardBlockId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlockBays/Get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (yardBlockId !== undefined) {
                localVarQueryParameter['YardBlockId'] = yardBlockId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [yardBlockId] 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockBaysIsUnique: async (name?: string, yardBlockId?: string, id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlockBays/IsUnique`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (yardBlockId !== undefined) {
                localVarQueryParameter['yardBlockId'] = yardBlockId;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [yardBlockBayId] 
         * @param {boolean} [lockStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockBaysSetLockStatus: async (yardBlockBayId?: string, lockStatus?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlockBays/SetLockStatus/lock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (yardBlockBayId !== undefined) {
                localVarQueryParameter['yardBlockBayId'] = yardBlockBayId;
            }

            if (lockStatus !== undefined) {
                localVarQueryParameter['lockStatus'] = lockStatus;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateYardBlockBayDto} [updateYardBlockBayDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockBaysUpdate: async (updateYardBlockBayDto?: UpdateYardBlockBayDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlockBays/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateYardBlockBayDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * YardBlockBaysApi - functional programming interface
 */
export const YardBlockBaysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = YardBlockBaysApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateYardBlockBayDto} [createYardBlockBayDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlockBaysCreate(createYardBlockBayDto?: CreateYardBlockBayDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YardBlockBayDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlockBaysCreate(createYardBlockBayDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlockBaysApi.yardBlockBaysCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [yardBlockBayId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlockBaysDelete(yardBlockBayId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlockBaysDelete(yardBlockBayId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlockBaysApi.yardBlockBaysDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [yardBlockId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlockBaysGet(yardBlockId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<YardBlockBayDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlockBaysGet(yardBlockId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlockBaysApi.yardBlockBaysGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [yardBlockId] 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlockBaysIsUnique(name?: string, yardBlockId?: string, id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlockBaysIsUnique(name, yardBlockId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlockBaysApi.yardBlockBaysIsUnique']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [yardBlockBayId] 
         * @param {boolean} [lockStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlockBaysSetLockStatus(yardBlockBayId?: string, lockStatus?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SlotDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlockBaysSetLockStatus(yardBlockBayId, lockStatus, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlockBaysApi.yardBlockBaysSetLockStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateYardBlockBayDto} [updateYardBlockBayDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlockBaysUpdate(updateYardBlockBayDto?: UpdateYardBlockBayDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YardBlockBayDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlockBaysUpdate(updateYardBlockBayDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlockBaysApi.yardBlockBaysUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * YardBlockBaysApi - factory interface
 */
export const YardBlockBaysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = YardBlockBaysApiFp(configuration)
    return {
        /**
         * 
         * @param {YardBlockBaysApiYardBlockBaysCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockBaysCreate(requestParameters: YardBlockBaysApiYardBlockBaysCreateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<YardBlockBayDto> {
            return localVarFp.yardBlockBaysCreate(requestParameters.createYardBlockBayDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {YardBlockBaysApiYardBlockBaysDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockBaysDelete(requestParameters: YardBlockBaysApiYardBlockBaysDeleteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.yardBlockBaysDelete(requestParameters.yardBlockBayId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {YardBlockBaysApiYardBlockBaysGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockBaysGet(requestParameters: YardBlockBaysApiYardBlockBaysGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<YardBlockBayDto>> {
            return localVarFp.yardBlockBaysGet(requestParameters.yardBlockId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {YardBlockBaysApiYardBlockBaysIsUniqueRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockBaysIsUnique(requestParameters: YardBlockBaysApiYardBlockBaysIsUniqueRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.yardBlockBaysIsUnique(requestParameters.name, requestParameters.yardBlockId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {YardBlockBaysApiYardBlockBaysSetLockStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockBaysSetLockStatus(requestParameters: YardBlockBaysApiYardBlockBaysSetLockStatusRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<SlotDto>> {
            return localVarFp.yardBlockBaysSetLockStatus(requestParameters.yardBlockBayId, requestParameters.lockStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {YardBlockBaysApiYardBlockBaysUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockBaysUpdate(requestParameters: YardBlockBaysApiYardBlockBaysUpdateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<YardBlockBayDto> {
            return localVarFp.yardBlockBaysUpdate(requestParameters.updateYardBlockBayDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for yardBlockBaysCreate operation in YardBlockBaysApi.
 */
export interface YardBlockBaysApiYardBlockBaysCreateRequest {
    readonly createYardBlockBayDto?: CreateYardBlockBayDto
}

/**
 * Request parameters for yardBlockBaysDelete operation in YardBlockBaysApi.
 */
export interface YardBlockBaysApiYardBlockBaysDeleteRequest {
    readonly yardBlockBayId?: string
}

/**
 * Request parameters for yardBlockBaysGet operation in YardBlockBaysApi.
 */
export interface YardBlockBaysApiYardBlockBaysGetRequest {
    readonly yardBlockId?: string
}

/**
 * Request parameters for yardBlockBaysIsUnique operation in YardBlockBaysApi.
 */
export interface YardBlockBaysApiYardBlockBaysIsUniqueRequest {
    readonly name?: string

    readonly yardBlockId?: string

    readonly id?: string
}

/**
 * Request parameters for yardBlockBaysSetLockStatus operation in YardBlockBaysApi.
 */
export interface YardBlockBaysApiYardBlockBaysSetLockStatusRequest {
    readonly yardBlockBayId?: string

    readonly lockStatus?: boolean
}

/**
 * Request parameters for yardBlockBaysUpdate operation in YardBlockBaysApi.
 */
export interface YardBlockBaysApiYardBlockBaysUpdateRequest {
    readonly updateYardBlockBayDto?: UpdateYardBlockBayDto
}

/**
 * YardBlockBaysApi - object-oriented interface
 */
export class YardBlockBaysApi extends BaseAPI {
    /**
     * 
     * @param {YardBlockBaysApiYardBlockBaysCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlockBaysCreate(requestParameters: YardBlockBaysApiYardBlockBaysCreateRequest = {}, options?: RawAxiosRequestConfig) {
        return YardBlockBaysApiFp(this.configuration).yardBlockBaysCreate(requestParameters.createYardBlockBayDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {YardBlockBaysApiYardBlockBaysDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlockBaysDelete(requestParameters: YardBlockBaysApiYardBlockBaysDeleteRequest = {}, options?: RawAxiosRequestConfig) {
        return YardBlockBaysApiFp(this.configuration).yardBlockBaysDelete(requestParameters.yardBlockBayId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {YardBlockBaysApiYardBlockBaysGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlockBaysGet(requestParameters: YardBlockBaysApiYardBlockBaysGetRequest = {}, options?: RawAxiosRequestConfig) {
        return YardBlockBaysApiFp(this.configuration).yardBlockBaysGet(requestParameters.yardBlockId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {YardBlockBaysApiYardBlockBaysIsUniqueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlockBaysIsUnique(requestParameters: YardBlockBaysApiYardBlockBaysIsUniqueRequest = {}, options?: RawAxiosRequestConfig) {
        return YardBlockBaysApiFp(this.configuration).yardBlockBaysIsUnique(requestParameters.name, requestParameters.yardBlockId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {YardBlockBaysApiYardBlockBaysSetLockStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlockBaysSetLockStatus(requestParameters: YardBlockBaysApiYardBlockBaysSetLockStatusRequest = {}, options?: RawAxiosRequestConfig) {
        return YardBlockBaysApiFp(this.configuration).yardBlockBaysSetLockStatus(requestParameters.yardBlockBayId, requestParameters.lockStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {YardBlockBaysApiYardBlockBaysUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlockBaysUpdate(requestParameters: YardBlockBaysApiYardBlockBaysUpdateRequest = {}, options?: RawAxiosRequestConfig) {
        return YardBlockBaysApiFp(this.configuration).yardBlockBaysUpdate(requestParameters.updateYardBlockBayDto, options).then((request) => request(this.axios, this.basePath));
    }
}

